var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/warning-field") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.0010294,4 L3,19.882301 L21.001,19.882301 L12.0010294,4 Z M10.9411505,14.5882007 L13.0598495,14.5882007 L13.0598495,10.3529204 L10.9411505,10.3529204 L10.9411505,14.5882007 Z M10.9411505,17.7657197 L13.0598495,17.7657197 L13.0598495,15.6470208 L10.9411505,15.6470208 L10.9411505,17.7657197 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "annotation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FORT---Fixture-Annotation-Copy",
    transform: "translate(-363.000000, -724.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/warning-field",
    transform: "translate(360.000000, 720.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "z_-Padding/Icons/Icon_Padding-_Null",
    transform: "translate(-1.000000, -1.000000)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colours/3-action-warning-red",
    mask: "url(#mask-2)",
    fill: "#FF1744",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIconRed);
export default __webpack_public_path__ + "static/media/WarningIconRed.68fdff43aec636e880d02d0efae6b766.svg";
export { ForwardRef as ReactComponent };